export default [
    {
        "year": 1985,
        "question": "我国新开发的准格尔煤矿位于（ ）",
        "A": "新疆",
        "B": "青海",
        "C": "内蒙古",
        "D": "陕西",
        "answer": "C"
    },
    {
        "year": 1986,
        "question": "我国新开发的准格尔煤矿位于（ ）",
        "A": "新疆",
        "B": "青海",
        "C": "内蒙古",
        "D": "陕西",
        "answer": "C"
    },
    {
        "year": 1987,
        "question": "我国新开发的准格尔煤矿位于（ ）",
        "A": "新疆",
        "B": "青海",
        "C": "内蒙古",
        "D": "陕西",
        "answer": "C"
    },
    {
        "year": 1988,
        "question": "黄河中下游地区的主要经济作物是（ ）",
        "A": "茶叶",
        "B": "棉花",
        "C": "甘蔗",
        "D": "亚麻",
        "answer": "B"
    },
    {
        "year": 1989,
        "question": "我国油料作物中，播种面积居首位的是（ ）",
        "A": "油菜",
        "B": "大豆",
        "C": "花生",
        "D": "芝麻",
        "answer": "A"
    },
    {
        "year": 1990,
        "question": "关于降水的叙述，正确的是（ ）",
        "A": "赤道低压带的降水主要是对流雨",
        "B": "常年受下沉气流控制的地区降水稀少",
        "C": "信风影响的地区必然少雨",
        "D": "面对海洋的山坡都是多雨区",
        "answer": "B"
    },
    {
        "year": 1991,
        "question": "形成地形雨、锋面雨和对流雨的共同必要条件是（ ）",
        "A": "空气中有足够的水汽",
        "B": "空气中有足够的凝结核",
        "C": "空气的水平运动",
        "D": "导致空气中上升运动的力",
        "answer": "A"
    },
    {
        "year": 1992,
        "question": "位于板块界线附近的山脉有（ ）",
        "A": "岗底斯山、新都库什山",
        "B": "阿特拉斯山、喜马拉雅山",
        "C": "洛基山、阿巴拉契亚山",
        "D": "安第斯山、内华达山",
        "answer": "B"
    },
    {
        "year": 1993,
        "question": "城市地面大面积下沉的主要原因是（ ）",
        "A": "植被遭破坏，水土流失加重",
        "B": "酸雨侵蚀地表",
        "C": "全球增温使海平面上升",
        "D": "过量抽取地下水",
        "answer": "D"
    },
    {
        "year": 1994,
        "question": "居世界前三位的炼油中心是（ ）",
        "A": "末京，芝加哥，北京",
        "B": "休斯敦，鹿特丹，新加坡",
        "C": "鹿特丹，横滨，新加坡",
        "D": "体斯教，阿伯丁，北京",
        "answer": "B"
    },
    {
        "year": 1995,
        "question": "居世界前三位的炼油中心是（ ）",
        "A": "末京，芝加哥，北京",
        "B": "休斯敦，鹿特丹，新加坡",
        "C": "鹿特丹，横滨，新加坡",
        "D": "体斯教，阿伯丁，北京",
        "answer": "B"
    },
    {
        "year": 1996,
        "question": "居世界前三位的炼油中心是（ ）",
        "A": "末京，芝加哥，北京",
        "B": "休斯敦，鹿特丹，新加坡",
        "C": "鹿特丹，横滨，新加坡",
        "D": "体斯教，阿伯丁，北京",
        "answer": "B"
    },
    {
        "year": 1997,
        "question": "下列水体中，水循环速度最快、周期最短的是（ ）",
        "A": "湖泊水",
        "B": "河流水",
        "C": "冰川水",
        "D": "地下水",
        "answer": "B"
    },
    {
        "year": 1998,
        "question": "我国东西走向的山脉有（  ）",
        "A": "冈底斯山、横断山、大兴安岭",
        "B": "天山、秦岭、南岭",
        "C": "长白山、太行山、贺兰山",
        "D": "喜马拉雅山、祁连山、小兴安岭",
        "answer": "B"
    },
    {
        "year": 1999,
        "question": "海尔集团将电冰箱等产品打人欧美市场，并不是依靠（ ）",
        "A": "企业的全球战略",
        "B": "对欧美人消费特点的掌握",
        "C": "世界级的技术水平和经营理念",
        "D": "自然资源优势和临海的地理位置优势",
        "answer": "D"
    },
    {
        "year": 2000,
        "question": "在我国西部大开发的战略中、“保护天然林”和“退耕还林(草)”是两项重要内容，采取这两项措施的首要目标是( )",
        "A": "开展生态旅游",
        "B": "发展畜牧业",
        "C": "增加木材产量",
        "D": "改善生态环境",
        "answer": "D"
    },
    {
        "year": 2001,
        "question": "可以吸收大量劳动力的服务业部门是（ ）",
        "A": "广告业",
        "B": "金融业",
        "C": "房屋装修业",
        "D": "互联网服务业",
        "answer": "C"
    },
    {
        "year": 2002,
        "question": "欧盟中央银行所在地法兰克福是德国（ ）",
        "A": "人口最多的城市",
        "B": "最大的港口城市",
        "C": "最大的航空枢纽城市",
        "D": "最大的高新技术工业中心",
        "answer": "C"
    },
    {
        "year": 2003,
        "question": "2001年，从西亚进口石油最多的地区是（ ）",
        "A": "西欧",
        "B": "美国",
        "C": "东亚和东南亚",
        "D": "大洋洲",
        "answer": "C"
    },
    {
        "year": 2004,
        "question": "当时从温州航海前往真腊的较佳时间是2/25（ ）",
        "A": "11~12月",
        "B": "3～4月",
        "C": "5～6月",
        "D": "7～8月",
        "answer": "A"
    },
    {
        "year": 2005,
        "question": "石灰岩受岩浆烘烤变质形成（ ）",
        "A": "砂岩",
        "B": "板岩",
        "C": "玄武岩",
        "D": "大理岩",
        "answer": "D"
    },
    {
        "year": 2006,
        "question": "农民用花基、菜基鱼塘取代桑基、蔗基的直接目的是（ ）",
        "A": "提高土壤质量",
        "B": "节省劳动力",
        "C": "促进生态循环",
        "D": "提高经济收入",
        "answer": "D"
    },
    {
        "year": 2007,
        "question": "在森林中一旦遭遇火灾，下列做法正确的是（ ）",
        "A": "使用沾湿的毛巾遮住口鼻，顺风逃离",
        "B": "如果火势突然减弱，则可以放心休息",
        "C": "选择低洼地或坑洞躲避",
        "D": "伺机逆风突破林火包围",
        "answer": "D"
    },
    {
        "year": 2008,
        "question": "对下列各地区环境叙述不正确的是（ ）",
        "A": "西北草原退化",
        "B": "东北草原土壤酸化",
        "C": "华北平原土壤盐渍化",
        "D": "南方丘陵水土流失",
        "answer": "B"
    },
    {
        "year": 2009,
        "question": "内力作用主要影响河流的（ ）",
        "A": "流向",
        "B": "含沙量",
        "C": "汛期",
        "D": "流量",
        "answer": "A"
    },
    {
        "year": 2010,
        "question": "利用作物秸杆等农副产品发展农区畜牧业，有利于( )",
        "A": "改善局地气候",
        "B": "综合利用资源",
        "C": "防止水土流失",
        "D": "保护农田作物",
        "answer": "B"
    },
    {
        "year": 2011,
        "question": "山西、内蒙古人均GDP不算高，但人均CO2排放量高。其主要原因是( )",
        "A": "自然资源贫乏",
        "B": "交通设施落后",
        "C": "煤炭消耗量大",
        "D": "第三产业发达",
        "answer": "C"
    },
    {
        "year": 2012,
        "question": "近年来，我国粮食总产量连续增长的主要原因是（ ）",
        "A": "扩大了粮食播种面积",
        "B": "加大了农业科技投入",
        "C": "改进了农田水利设施",
        "D": "完善了粮食流通体系",
        "answer": "B"
    },
    {
        "year": 2013,
        "question": "温州瓜农选择在海南岛种植西瓜，是因为海南岛（ ）",
        "A": "西瓜品种优",
        "B": "种植成本低",
        "C": "种植利润高",
        "D": "市场需求大",
        "answer": "C"
    },
    {
        "year": 2014,
        "question": "农民建“握手楼”的直接目的是（ ）",
        "A": "吸引外来人口定居",
        "B": "吸引市民周末度假",
        "C": "增加自主住房屋面积",
        "D": "出租房屋增加收入",
        "answer": "D"
    },
    {
        "year": 2015,
        "question": "推测目前没有大规模开采渤海海冰的原因是（ ）",
        "A": "资源量不足",
        "B": "破坏环境",
        "C": "成本过高",
        "D": "市场需求不足",
        "answer": "C"
    },
    {
        "year": 2016,
        "question": "与景德镇相比，20世纪80年代佛山瓷业迅速发展的主要原因是（ ）",
        "A": "市场广阔",
        "B": "原材料充足",
        "C": "劳动力素质高",
        "D": "国家政策倾斜",
        "answer": "D"
    },
    {
        "year": 2017,
        "question": "海德堡印刷机在国际市场长期保持竞争优势，主要依赖于",
        "A": "产量大",
        "B": "价格低",
        "C": "款式新",
        "D": "质量优",
        "answer": "D"
    },
    {
        "year": 2018,
        "question": "在地表水匮乏地区，煤制油企业长期用水宜采用的方式是（  ）",
        "A": "循环用水",
        "B": "开发地下水",
        "C": "远程调水",
        "D": "建地下水窖",
        "answer": "A"
    },
    {
        "year": 2019,
        "question": "夏至日前后，俄罗斯圣彼得堡(60y)会出现夜晚不黑现象，这是因为大气对太阳辐射具有（    ）",
        "A": "折射作用",
        "B": "反射作用",
        "C": "吸收作用",
        "D": "散射作用",
        "answer": "D"
    },
    {
        "year": 2020,
        "question": "人工岛的地下淡水一般不作为日常生产生活水源，主要因为其（ ）",
        "A": "取水难度大",
        "B": "开采周期长",
        "C": "水质较差",
        "D": "储量较少",
        "answer": "D"
    }
]